import HeaderCardTenis from './headerCardTenis/headerCardTenis';
import BodyCardTenis from './bodyCardTenis/bodyCardTenis';
import FooterCardTenis from './footerCardTenis/footerCardTenis';
import { getSponsorClass } from '../../../../functions/functions';
import './cardTenis.sass';

/**
 * Componente para renderizar una tarjeta de evento deportivo de tenis
 * dentro del carrusel patrocinado. 
 * Muestra un encabezado, cuerpo y pie condicional dependiendo del estado del juego y si hay momios.
 */
export default function CardTenis({ data, flagMomios, patrocinador, indexJson }) {
  const isActiveGame = !['clarosports-finished-game', 'clarosports-error-game'].includes(data.class);
  const showMomios = (flagMomios === true || flagMomios === 'true') && isActiveGame;

  return (
    <div className={`carrousel-card-sponsored card-tenis ${getSponsorClass(patrocinador)}`}>
      {/* Encabezado del card (fecha, torneo, lugar, etc.) */}
      <HeaderCardTenis data={data} indexJson={indexJson} />

      {/* Cuerpo principal del partido (jugadores, marcador, sets, etc.) */}
      <BodyCardTenis data={data} flagMomios={flagMomios} patrocinador={patrocinador} />

      {/* Pie de tarjeta solo si aplica mostrar momios */}
      {showMomios
        ? <FooterCardTenis data={data} patrocinador={patrocinador} />
        : <div className='card-tenis__footer_empty'></div>
      }
    </div>
  )
}